import router from "@/router";
import RouteNames from "@/router/RouteNames.ts";
import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import ViewMode from "@/utils/constants/ViewMode.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";

export default class ThemeUtils {
  static async goToMyGuiTheme() {
    const response = await NamaCommon.namaFetch(NamaURLS.FindOrCreateMyTheme, {});
    if (!response || !response.id)
      return;
    const id = response?.id ?? '';
    await router.push({
      name: RouteNames.EDIT_VIEW_ROUTE,
      query: {
        [PlaceTokens.PRM_ENTITY_TYPE]: BSCEntities.GUITheme,
        [PlaceTokens.PRM_VIEW]: ViewMode.EDIT,
        [PlaceTokens.PRM_ID]: id
      }
    });
  }
}
